import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/styles.css';
import './mobile.css';
import App from './App';

/* --- Keş özünü sağaltma ---
   E-poçtdakı linkə basanda səhifə bəzən üslubsuz (ağ, köhnə "word" görünüşlü)
   açılırdı: brauzerdə qalmış köhnə service worker köhnə index.html-i verir,
   onun göstərdiyi CSS faylı isə artıq serverdə yoxdur. Nəticədə JS işləyir,
   CSS düşmür. Ctrl+Shift+R də kömək etmir, çünki cavabı service worker verir.

   Aşağıdakı yoxlama index.css-dəki --ems-css nişanını axtarır. Nişan yoxdursa,
   CSS tətbiq olunmayıb: bütün service worker-ləri silir, keşləri boşaldır və
   səhifəni bir dəfə yenidən yükləyir. sessionStorage açarı sonsuz döngənin
   qarşısını alır — bir cəhddən sonra təkrar etmir. */
function cssYuklendi() {
  const v = getComputedStyle(document.documentElement).getPropertyValue('--ems-css');
  return v && v.trim() === 'ok';
}

async function kesiTemizleVeYenile() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    }
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
  } catch {}
  window.location.reload();
}

window.addEventListener('load', () => {
  // Üslublar gec qoşula bilər — bir az gözləyib yoxlayırıq
  setTimeout(() => {
    if (cssYuklendi()) {
      sessionStorage.removeItem('ems_kes_temizlendi');
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
      }
      return;
    }
    if (sessionStorage.getItem('ems_kes_temizlendi')) return; // artıq bir dəfə cəhd etmişik
    sessionStorage.setItem('ems_kes_temizlendi', '1');
    kesiTemizleVeYenile();
  }, 600);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
